/**
 * Map Module
 * Handles OpenStreetMap integration with Leaflet
 */

import L from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Fix Leaflet's default icon paths for bundlers
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});

/**
 * Initialize all maps on the page
 */
export const initMaps = () => {
    const mapContainers = document.querySelectorAll('.osm-map');

    if (mapContainers.length === 0) return;

    mapContainers.forEach(container => {
        initMap(container);
    });
};

/**
 * Initialize a single map
 */
const initMap = (container) => {
    // Get coordinates and zoom from data attributes
    const lat = parseFloat(container.dataset.lat);
    const lon = parseFloat(container.dataset.lon);
    const zoom = parseInt(container.dataset.zoom) || 15;
    const markerTitle = container.dataset.title || 'Thom Umzug';

    // Validate coordinates
    if (isNaN(lat) || isNaN(lon)) {
        console.error('Invalid map coordinates:', { lat, lon });
        return;
    }

    // Create map instance
    const map = L.map(container, {
        scrollWheelZoom: false // Disable scroll zoom by default
    }).setView([lat, lon], zoom);

    // Add OpenStreetMap tiles
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 19
    }).addTo(map);

    // Add marker
    const marker = L.marker([lat, lon]).addTo(map);

    // Add popup if title is provided
    if (markerTitle) {
        marker.bindPopup(markerTitle);
    }

    // Enable scroll zoom on click
    container.addEventListener('click', () => {
        map.scrollWheelZoom.enable();
    });

    // Disable scroll zoom when leaving the map
    container.addEventListener('mouseleave', () => {
        map.scrollWheelZoom.disable();
    });
};
